import { Field as BaseField, type FieldLabelProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { labelStyle } from './RadioLabel.css';

type Props = FieldLabelProps;

export const RadioLabel = ({ ...delegated }: Props) => {
  return <BaseField.Label {...delegated} className={clsxs(labelStyle, delegated.className)} />;
};
